<template>
    <transition name="fade" appear @before-enter="beforeEnter" @enter="enter" @leave="leave">
        <div v-if="isVisible" v-on:mouseenter="enterMenu" v-on:mouseleave="leaveMenu" class="full-categories-menu bg-white">
            <!-- 하위 카테고리 메뉴 -->
            <div class="category-content">
                <div>
                    <div v-for="(item, idx) in menuList" class="menu-list">
                        <!-- <a href="" class="first-depth-a">{{ item.name }}</a> -->
                        <router-link :to="item.href || '/'">{{ item.name }}</router-link>
                        <ul>
                            <li
                                v-for="(item2, idx2) in item.children"
                                class="depth-2"
                                :class="[item2.class || '', { 'no-arrow': !item2 || !item2.children }]"
                                @mouseover="hoverIdx = [idx, idx2]"
                            >
                                <a :href="item2.href ? `/product/${item2.href}` : item2.children?.[0]?.href ? `/product/${item2.children[0].href}` : '#'">
                                    <span>{{ item2.name.split('] ')[1] || item2.name }}</span>
                                </a>
                                <ul v-if="item2 && item2.children" class="last-depth-ul">
                                    <li v-for="item3 in item2.children" :class="item3.class">
                                        <a :href="item3.href ? `/product/${item3.href}` : '#'" :class="!item3.href ? 'cursor-default' : ''">
                                            <span>{{ item3.name.split('] ')[1] || item3.name }}</span>
                                        </a>
                                        <i class="n-icon">N</i>
                                        <i class="h-icon">H</i>
                                        <i class="b-icon">B</i>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- 오른쪽 로고와 설명 -->
                <div class="right-info">
                    <div class="top-field">
                        <img :src="`/assets/img/dummyImgs/dummy${hoverIdx[0]}/0.png`" />
                        <strong>{{ dummyData[hoverIdx[0]]?.[hoverIdx[1]].title }}</strong>
                        <ul>
                            <li v-for="tag in dummyData[hoverIdx[0]]?.[hoverIdx[1]].tags.split(',')">{{ tag.trim() }}</li>
                        </ul>
                    </div>
                    <div class="bottom-field">
                        <p>
                            환경친화적 인쇄를 지향하는
                            <br />
                            인쇄의 넘버원,
                            <strong>프리원!</strong>
                        </p>
                        <img src="/assets/img/soyinkmark.svg" />
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import { VListItemSubtitle } from 'vuetify/lib';
    import { mapGetters } from 'vuex';

    export default {
        props: {
            show: { type: Boolean, required: true, default: false },
        },
        computed: {
            ...mapGetters('app', ['demoMode']),
            isVisible: {
                get() {
                    return this.show;
                },
                set(value) {
                    this.show = value;
                },
            },
            menuList() {
                return this.baseMenuList.filter((item) => !item.demoOnly || this.demoMode);
            },
            dummyData() {
                return this.baseMenuList
                    .map((item, i) => ({ item, data: this.baseDummyData[i] }))
                    .filter(({ item }) => !item.demoOnly || this.demoMode)
                    .map(({ data }) => data);
            },
        },
        data: () => ({
            dialog: false,
            hoverIdx: [0, 0],
            baseDummyData: [
                [
                    {
                        title: '디지털 무선책자',
                        tags: '#빠른 제작, #소량인쇄, #고해상도, #합리적 가격',
                    },
                    {
                        title: '디지털 무선책자 (고품질잉크젯)',
                        tags: '#빠른 제작, #소량인쇄, #고해상도, #합리적 가격',
                    },
                    {
                        title: '디지털 일반지 포스터',
                        tags: '#빠른 제작, #소량인쇄, #고해상도, #합리적 가격',
                    },
                    {
                        title: '디지털 무선 카탈로그',
                        tags: '#빠른 제작, #소량인쇄, #고해상도, #합리적 가격',
                    },
                    {
                        title: '디지털 일반지 리플렛',
                        tags: '#빠른 제작, #소량인쇄, #고해상도, #합리적 가격',
                    },
                    {
                        title: '디지털 전단지',
                        tags: '#빠른 제작, #소량인쇄, #고해상도, #합리적 가격',
                    },
                    {
                        title: '디지털 초대장/안내장',
                        tags: '#빠른 제작, #소량인쇄, #고해상도, #합리적 가격',
                    },
                    {
                        title: '디지털 엽서',
                        tags: '#빠른 제작, #소량인쇄, #고해상도, #합리적 가격',
                    },
                    {
                        title: '디지털 일반지 명함',
                        tags: '#빠른 제작, #소량인쇄, #고해상도, #합리적 가격',
                    },
                    {
                        title: '디지털 탁상용 캘린더(가로형)',
                        tags: '#빠른 제작, #소량인쇄, #맞춤형 삼각대',
                    },
                    {
                        title: '디지털 낱장인쇄',
                        tags: '#빠른 제작, #소량인쇄, #고해상도, #합리적 가격',
                    },
                ],
                [
                    {
                        title: '옵셋 무선책자',
                        tags: '#빠른 제작, #소량인쇄, #고해상도, #합리적 가격',
                    },
                    {
                        title: '옵셋 일반지 포스터',
                        tags: '#빠른 제작, #소량인쇄, #고해상도, #합리적 가격',
                    },
                    {
                        title: '옵셋 무선 카탈로그',
                        tags: '#빠른 제작, #소량인쇄, #고해상도, #합리적 가격',
                    },
                    {
                        title: '옵셋 일반지 리플렛',
                        tags: '#빠른 제작, #소량인쇄, #고해상도, #합리적 가격',
                    },
                    {
                        title: '옵셋 전단지',
                        tags: '#빠른 제작, #소량인쇄, #고해상도, #합리적 가격',
                    },
                    {
                        title: '옵셋 초대장/안내장',
                        tags: '#빠른 제작, #소량인쇄, #고해상도, #합리적 가격',
                    },
                    {
                        title: '옵셋 엽서',
                        tags: '#빠른 제작, #소량인쇄, #고해상도, #합리적 가격',
                    },
                    {
                        title: '옵셋 일반지 명함',
                        tags: '#빠른 제작, #소량인쇄, #고해상도, #합리적 가격',
                    },
                    {
                        title: '옵셋 낱장인쇄',
                        tags: '#빠른 제작, #소량인쇄, #고해상도, #합리적 가격',
                    },
                ],
                [
                    { title: '배너', tags: '#빠른 제작, #소량인쇄, #고해상도, #합리적 가격' },
                    { title: '현수막', tags: '#빠른 제작, #소량인쇄, #고해상도, #합리적 가격' },
                    { title: '실사출력', tags: '#빠른 제작, #소량인쇄, #고해상도, #합리적 가격' },
                ],
            ],
            baseMenuList: [
                //햄버거 버튼 눌렀을때의 메뉴 리스트(임시(나중에 db화 해야함))
                {
                    name: '디지털 인쇄',
                    depth: 0,
                    href: '/all-digital-printing',
                    children: [
                        {
                            name: '디지털 책자',
                            depth: 1,
                            href: '',
                            children: [
                                {
                                    name: '무선책자',
                                    depth: 2,
                                    href: 'book-digital-wireless',
                                },
                                {
                                    name: '중철책자',
                                    depth: 2,
                                    href: 'book-digital-stitch',
                                },
                                {
                                    name: '트윈링책자',
                                    depth: 2,
                                    href: 'book-digital-twinring',
                                    // class: 'n b h',
                                },
                                {
                                    name: '코일링책자',
                                    depth: 2,
                                    href: 'book-digital-coilring',
                                    // class: 'n b h',
                                },
                            ],
                        },
                        {
                            name: '디지털 책자 (고품질잉크젯)',
                            depth: 1,
                            href: '',
                            children: [
                                {
                                    name: '무선책자',
                                    depth: 2,
                                    href: 'digital-perfect-booklet-on-inkjet',
                                },
                                {
                                    name: '중철책자',
                                    depth: 2,
                                    href: 'digital-saddle-booklet-on-inkjet',
                                },
                                {
                                    name: '트윈링책자',
                                    depth: 2,
                                    href: 'digital-twinring-booklet-on-inkjet',
                                },
                            ],
                        },
                        {
                            name: '디지털 포스터',
                            depth: 1,
                            href: '',
                            children: [
                                {
                                    name: '일반지 포스터',
                                    depth: 2,
                                    href: 'poster-digital-general',
                                },
                                {
                                    name: '고급지 포스터',
                                    depth: 2,
                                    href: 'poster-digital-premium',
                                    class: 'n h',
                                },
                                /***{
                                name: '펄지 포스터',
                                depth: 2,
                                href: 'poster-digital-pearl',
                            },***/
                                /***{
                                name: '특수지 포스터',
                                depth: 2,
                                href: 'poster-digital-special',
                            },***/
                            ],
                        },
                        {
                            name: '디지털 카탈로그',
                            depth: 1,
                            href: '',
                            children: [
                                {
                                    name: '무선 카탈로그',
                                    depth: 2,
                                    href: 'catalog-digital-wireless',
                                },
                                {
                                    name: '중철 카탈로그',
                                    depth: 2,
                                    href: 'catalog-digital-stitch',
                                },
                                {
                                    name: '트윈링 카탈로그',
                                    depth: 2,
                                    href: 'catalog-digital-twinring',
                                },
                            ],
                        },
                        {
                            name: '디지털 리플렛',
                            depth: 1,
                            href: '',
                            children: [
                                {
                                    name: '일반지 리플렛',
                                    depth: 2,
                                    href: 'leaflet-digital-general',
                                },
                                {
                                    name: '고급지 리플렛',
                                    depth: 2,
                                    href: 'leaflet-digital-premium',
                                },
                                /***{
                                name: '펄지 리플렛',
                                depth: 2,
                                href: 'leaflet-digital-pearl',
                                class: 'n',
                            },***/
                                /***{
                                name: '특수지 리플렛',
                                depth: 2,
                                href: 'leaflet-digital-spacial',
                                class: 'n',
                            },***/
                            ],
                        },
                        {
                            name: '디지털 전단지',
                            depth: 1,
                            href: '',
                            children: [
                                {
                                    name: '전단지',
                                    depth: 2,
                                    href: 'sheet-digital-normal',
                                },
                            ],
                        },
                        {
                            name: '디지털 초대장',
                            depth: 1,
                            href: '',
                            children: [
                                {
                                    name: '초대장/안내장',
                                    depth: 2,
                                    href: 'card-digital-visit',
                                    class: 'n h',
                                },
                                {
                                    name: '상품권/티켓',
                                    depth: 2,
                                    href: 'card-digital-ticket',
                                },
                                {
                                    name: '쿠폰',
                                    depth: 2,
                                    href: 'card-digital-coupon',
                                },
                            ],
                        },
                        {
                            name: '디지털 엽서',
                            depth: 1,
                            href: '',
                            children: [
                                {
                                    name: '엽서',
                                    depth: 2,
                                    href: 'card-digital-postcard',
                                },
                            ],
                        },
                        {
                            name: '디지털 명함',
                            depth: 1,
                            href: '',
                            children: [
                                {
                                    name: '일반지 명함',
                                    depth: 2,
                                    href: 'businesscard-digital-general',
                                },
                                {
                                    name: '고급지 명함',
                                    depth: 2,
                                    href: 'businesscard-digital-premium',
                                },
                                /***{
                                name: '펄지 명함',
                                depth: 2,
                                href: 'businesscard-digital-pearl',
                                class: 'b',
                            },***/
                                /***{
                                name: '특수지 명함',
                                depth: 2,
                                href: 'businesscard-digital-special',
                            },***/
                            ],
                        },
                        /***{
                        name: '디지털 스티커',
                        depth: 1,
                        href: '',
                        children: [
                            {
                                name: '재단형 스티커',
                                depth: 2,
                                href: '',
                            },
                            {
                                name: '톰슨형 스티커',
                                depth: 2,
                                href: '',
                            },
                        ],
                    },***/
                        {
                            name: '디지털 캘린더',
                            depth: 1,
                            href: 'calendar-digital-desktop',
                            children: [
                                {
                                    name: '탁상용 캘린더(가로형)',
                                    depth: 2,
                                    href: 'calendar-digital-desktop',
                                },
                                {
                                    name: '탁상용 캘린더(세로형)',
                                    depth: 2,
                                    href: 'calendar-digital-desktop2',
                                },
                                {
                                    name: '미니 캘린더',
                                    depth: 2,
                                    href: 'calendar-digital-desktop3',
                                },
                                {
                                    name: '벽걸이 캘린더',
                                    depth: 2,
                                    href: 'calendar-digital-walltype',
                                },
                            ],
                        },
                        {
                            name: '디지털 낱장인쇄',
                            depth: 1,
                            href: 'single-sheet-digital-normal',
                            children: [
                                {
                                    name: '낱장인쇄',
                                    depth: 2,
                                    href: 'single-sheet-digital-normal',
                                },
                            ],
                        },
                        /***{
                            name: '디지털 봉투/쇼핑백',
                            depth: 1,
                            href: '',
                            children: [
                                {
                                    name: '봉투',
                                    depth: 2,
                                    href: '/product/envelope-digital',
                                },
                                {
                                    name: '쇼핑백',
                                    depth: 2,
                                    href: '/product/shoppingbag-digital',
                                },
                            ],
                        },/***/
                    ],
                },
                {
                    name: '옵셋 인쇄',
                    depth: 0,
                    href: '/all-offset-printing',
                    demoOnly: true,
                    children: [
                        {
                            name: '옵셋 책자',
                            depth: 1,
                            href: '',
                            children: [
                                {
                                    name: '무선책자',
                                    depth: 2,
                                    href: 'book-offset-wireless',
                                },
                                {
                                    name: '중철책자',
                                    depth: 2,
                                    href: 'book-offset-stitch',
                                },
                                {
                                    name: '트윈링책자',
                                    depth: 2,
                                    href: 'book-offset-twinring',
                                    class: 'n b h',
                                },
                                {
                                    name: '코일링책자',
                                    depth: 2,
                                    href: 'book-offset-coilring',
                                    class: 'n b h',
                                },
                            ],
                        },
                        {
                            name: '옵셋 포스터',
                            depth: 1,
                            href: '',
                            children: [
                                {
                                    name: '일반지 포스터',
                                    depth: 2,
                                    href: 'sheet-poster-general',
                                },
                                {
                                    name: '고급지 포스터',
                                    depth: 2,
                                    href: 'sheet-poster-premium',
                                    class: 'n h',
                                },
                            ],
                        },
                        {
                            name: '옵셋 카탈로그',
                            depth: 1,
                            href: '',
                            children: [
                                {
                                    name: '무선 카탈로그',
                                    depth: 2,
                                    href: 'catalog-offset-catalog',
                                },
                                {
                                    name: '중철 카탈로그',
                                    depth: 2,
                                    href: 'catalog-offset-stitch',
                                },
                                {
                                    name: '트윈링 카탈로그',
                                    depth: 2,
                                    href: 'catalog-offset-twinring',
                                },
                            ],
                        },
                        {
                            name: '옵셋 리플렛',
                            depth: 1,
                            href: '',
                            children: [
                                {
                                    name: '일반지 리플렛',
                                    depth: 2,
                                    href: 'leaflet-offset-general',
                                },
                                {
                                    name: '고급지 리플렛',
                                    depth: 2,
                                    href: 'leaflet-offset-premium',
                                },
                            ],
                        },
                        {
                            name: '옵셋 전단지',
                            depth: 1,
                            href: '',
                            children: [
                                {
                                    name: '전단지',
                                    depth: 2,
                                    href: 'sheet-offset-normal',
                                },
                            ],
                        },
                        {
                            name: '옵셋 초대장',
                            depth: 1,
                            href: '',
                            children: [
                                {
                                    name: '초대장/안내장',
                                    depth: 2,
                                    href: 'card-offset-visit',
                                    class: 'n h',
                                },
                                {
                                    name: '상품권/티켓',
                                    depth: 2,
                                    href: 'card-offset-ticket',
                                },
                                {
                                    name: '쿠폰',
                                    depth: 2,
                                    href: 'card-offset-coupon',
                                },
                            ],
                        },
                        {
                            name: '옵셋 엽서',
                            depth: 1,
                            href: '',
                            children: [
                                {
                                    name: '엽서',
                                    depth: 2,
                                    href: 'card-offset-postcard',
                                },
                            ],
                        },
                        {
                            name: '옵셋 명함',
                            depth: 1,
                            href: '',
                            children: [
                                {
                                    name: '일반지 명함',
                                    depth: 2,
                                    href: 'businesscard-offset-general',
                                },
                                {
                                    name: '고급지 명함',
                                    depth: 2,
                                    href: 'businesscard-offset-premium',
                                },
                            ],
                        },
                        {
                            name: '옵셋 낱장인쇄',
                            depth: 1,
                            href: 'single-sheet-offset-normal',
                            children: [
                                {
                                    name: '낱장인쇄',
                                    depth: 2,
                                    href: 'single-sheet-offset-normal',
                                },
                            ],
                        },
                    ],
                },
                {
                    name: '실사출력',
                    depth: 0,
                    href: '/all-largeformat-printing',
                    children: [
                        {
                            name: '배너',
                            depth: 1,
                            href: '',
                            class: 'special',
                            children: [
                                {
                                    name: '실내용 배너',
                                    depth: 2,
                                    href: 'stand-banner',
                                },
                                {
                                    name: '실외용 배너',
                                    depth: 2,
                                    href: 'outdoor-banner',
                                },
                                {
                                    name: '미니배너',
                                    depth: 2,
                                    href: 'mini-banner',
                                },
                            ],
                        },
                        {
                            name: '현수막',
                            depth: 1,
                            href: 'largeformat-hanging-general',
                            class: 'special',
                        },
                        {
                            name: '실사출력',
                            depth: 2,
                            href: 'largeformat-printing-general',
                        },
                    ],
                },
                /*** {
                    name: '친환경 인쇄',
                    depth: 0,
                    href: '/eco-printing',
                    children: [
                        {
                            name: '친환경 옵셋',
                            depth: 1,
                            href: 'eco-offset-sheet',
                        },
                        {
                            name: '친환경 실사출력',
                            depth: 1,
                            href: '',
                            children: [
                                {
                                    name: '친환경 배너',
                                    depth: 2,
                                    href: '',
                                },
                                {
                                    name: '친환경 현수막',
                                    depth: 2,
                                    href: '',
                                },
                            ],
                        },
                        {
                            name: '프리원의 친환경 인쇄',
                            depth: 1,
                            href: 'eco-offset-sheet',
                            class: 'special2',
                        },
                    ],
                }, /***/
            ],
            entered: false,
        }),
        methods: {
            async getTerms() {
                const res = await this.call_api('get', `page/terms-and-conditions`);
                if (res.data.success) {
                    // console.log('data', res.data);
                    this.terms = res.data.data.content;
                } else {
                    this.snack({
                        message: res.data.message,
                        color: 'red',
                    });
                    this.$router.push({ name: '404' });
                }
                this.loading = false;
            },

            goMenu(path) {
                window.location.href = path;
                //this.$router.push({ path: path });
                //this.$emit('close');
            },
            beforeEnter(el) {
                el.style.opacity = 0;
                el.style.transform = 'translateY(-20px)';
                el.style.transition = 'opacity 0.4s ease, transform 0.5s ease';
            },
            enter(el, done) {
                // force reflow
                void el.offsetWidth;
                el.style.opacity = 1;
                el.style.transform = 'translateY(0)';

                setTimeout(done, 400); // same as transition duration
            },
            leave(el, done) {
                el.style.opacity = 0;
                el.style.transform = 'translateY(-20px)';

                setTimeout(done, 400);
            },
            enterMenu() {
                this.entered = true;
            },
            leaveMenu() {
                if (this.entered === true) {
                    this.entered = false;
                    this.$emit('close');
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .cursor-default {
        cursor: default;
        opacity: 0.5;
    }
    .full-categories-menu {
        z-index: 1000;
        position: absolute;
        width: 100%;
        /* top: 200px; */
        left: 0;
        padding: 0;
        /* border-bottom: 1px solid #ddd; */
        border-top: 1px solid #ddd;
        background-color: white;
        white-space: nowrap;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-shadow: 0px 20px 30px -40px rgb(0 0 0 / 40%);
    }

    /* 상단 메뉴 스타일 */
    .category-header {
        display: flex;
        align-items: center;
        height: 60px;
        padding: 0 20px;
        border-bottom: 1px solid #eee;
    }

    .category-header a {
        margin: 0 15px;
        font-size: 15px;
        font-weight: 500;
        color: #333;
        text-decoration: none;
    }

    /* 오른쪽 아이콘 */
    .right-icons {
        margin-left: auto;
        display: flex;
        align-items: center;
    }

    .icon-search,
    .icon-user,
    .icon-delivery,
    .icon-cart {
        margin-left: 20px;
        width: 24px;
        height: 24px;
        position: relative;
    }

    .cart-count {
        position: absolute;
        top: -8px;
        right: -8px;
        background-color: red;
        color: white;
        font-size: 12px;
        width: 18px;
        height: 18px;
        line-height: 18px;
        text-align: center;
        border-radius: 50%;
    }

    /* 하위 카테고리 컨테이너 */
    .category-content {
        display: flex;
        /* padding: 20px; */
        padding: 25px 20px 40px;

        position: relative;
        &:before {
            content: '';
            width: 1px;
            position: absolute;
            top: 25px;
            bottom: 40px;
            left: 166px;
            background: #e5e5e5;
        }
    }

    /* 카테고리 리스트 스타일 */
    .category-list {
        padding-left: 10px;
        padding-right: 32px;
        margin: 0;
        list-style: none;
        min-width: 150px;
        border-right: 1px solid #eee;
    }

    .category-title {
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 8px;
        color: #333;
        border: none;
    }

    .category-item {
        margin: 5px 0;
        padding: 0;
        border: none;
        font-size: 14px;
    }

    .category-item a {
        color: #555;
        text-decoration: none;
    }

    .category-item a:hover {
        color: #000;
    }

    .no-border {
        border: 0 !important;
    }

    /* 추가 카테고리와 로고 스타일 */
    .additional-categories {
        display: flex;
        flex-direction: column;
    }

    .right-info {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        margin-left: 47px;

        .top-field {
            img {
                width: 300px;
                display: block;
                margin-bottom: 10px;
            }

            strong {
                font-weight: 500;
                font-size: 14px;
                line-height: 15px;
                vertical-align: middle;
                display: block;
                margin-bottom: 6px;
            }
            ul {
                list-style: none;
                display: flex;
                align-items: center;

                color: #07120c;

                font-size: 12px;
                font-style: normal;

                margin: 0 0 10px;
                padding: 0;

                li {
                    margin-right: 10px;
                    line-height: 13px;

                    &:last-of-type {
                        margin-right: 0;
                    }
                }
            }

            a {
                color: #3e7af2;
                font-size: 14px;
                font-style: normal;
                font-weight: 500;
                line-height: 20px;
                vertical-align: middle;
            }
        }

        .bottom-field {
            text-align: right;

            p {
                font-size: 14px;
                line-height: 130%;

                color: #1e5e2a;

                strong {
                    font-weight: 500;
                }

                margin: 0 0;
            }

            img {
                vertical-align: top;
            }
        }
    }

    .menu-list {
        list-style: none;
        margin: 0;
        padding: 0;
        display: flex;
        margin-bottom: 20px;

        &:hover > a {
            font-weight: 500;
        }

        &:last-of-type {
            margin-bottom: 0;
        }

        ul {
            list-style: none;
            margin: 0;
            padding: 0;
        }

        & > a {
            position: relative;
            width: 148px;
            /* border-right: 1px solid #E5E5E5; */

            color: #000;

            font-size: 18px;
            font-style: normal;

            line-height: 130%;
            margin-right: 20px;

            &.active {
                font-weight: 500;
                color: #07120c;
            }

            &:after {
                content: url(/assets/img/menu-arrow.svg);
                display: flex;
                position: absolute;
                top: 8px;
                right: 20px;
            }
        }

        & > ul {
            flex: 1 0 1px;
        }

        .depth-2 {
            display: flex;
            margin-bottom: 4px;

            &:last-of-type {
                margin-bottom: 0;
            }

            &:hover > a {
                font-weight: 500;
            }

            & > a {
                width: 175px;
                position: relative;
                margin-right: 50px;

                color: #000;

                font-size: 14px;
                font-style: normal;

                line-height: 130%; /* 18.2px */

                transition: none;

                &.active {
                    font-weight: 500;
                }

                &:hover > span {
                    font-weight: 500;

                    &:after {
                        width: 100%;
                    }
                }

                &:after {
                    content: url(/assets/img/menu-arrow.svg);
                    display: flex;
                    position: absolute;
                    top: 5px;
                    right: 0;
                }

                span {
                    position: relative;

                    &:after {
                        content: '';
                        position: absolute;
                        bottom: -2px;
                        left: 0;
                        width: 0;
                        transition: width 0.5s;
                        height: 2px;
                        background: #000;
                    }
                }
            }

            &.no-arrow > a:after {
                display: none;
            }

            &.special > ul {
                flex: 0 0 auto;
                width: 567px;

                li:nth-of-type(4) {
                    width: 177px;
                    margin-top: 10px;
                }
                li:nth-of-type(5) {
                    width: 177px;
                    margin-top: 10px;
                }
            }

            &.special2 > a {
                color: #127017;
                span:after {
                    background: #127017;
                }
            }
        }

        .last-depth-ul {
            display: flex;
            flex-wrap: wrap;
            flex: 1 0 1px;

            li {
                margin-right: 30px;

                &:nth-of-type(1) {
                    width: 177px;
                }
                &:nth-of-type(2) {
                    width: 177px;
                }
                &:nth-of-type(3) {
                    width: 123px;
                }

                a {
                    color: #000;

                    font-size: 14px;
                    font-style: normal;

                    line-height: normal;

                    transition: none;
                    position: relative;

                    &:not(.cursor-default):hover > span {
                        font-weight: 500;
                        &:after {
                            width: 100%;
                        }
                    }

                    /* &.h:after{
                    content: url(/assets/img/h-icon.svg);
                    vertical-align: top;
                    position: relative;
                    top: -1px;
                } */

                    span {
                        position: relative;

                        &:after {
                            content: '';
                            position: absolute;
                            bottom: -2px;
                            left: 0;
                            width: 0;
                            transition: width 0.5s;
                            height: 2px;
                            background: #000;
                        }
                    }
                }

                i {
                    width: 12px;
                    height: 12px;
                    border-radius: 50%;
                    align-items: center;
                    justify-content: center;

                    vertical-align: middle;

                    color: #fff;
                    font-size: 7px;

                    font-style: normal;
                    display: none;
                    position: relative;
                    top: -1px;

                    &.h-icon {
                        background: #c20000;
                    }
                    &.n-icon {
                        background: #3e7af2;
                    }
                    &.b-icon {
                        background: #127017;
                    }
                }

                &.h {
                    i.h-icon {
                        display: inline-flex;
                    }
                }
                &.n {
                    i.n-icon {
                        display: inline-flex;
                    }
                }
                &.b {
                    i.b-icon {
                        display: inline-flex;
                    }
                }
            }
        }
    }
</style>
